import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style13({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="squared"
      onClick={onClick}
    />
  );
}
